import executiveService from '@/services/executiveService';

// Lógica común de una pestaña de reporte ejecutivo: corre el reporte con los filtros
// vigentes, mantiene el estado de drill-down y exporta a Excel. Cada pestaña define
// `reportName` (o lo pasa a run()) y renderiza summary/rows con KpiCard y DrillTable.
export default {
  props: {
    filters: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      loading: false,
      summary: {},
      rows: [],
      meta: {},
      total: 0,
      page: 1,
      perPage: 50,
      drillPath: [], // [{ level, key, label }]
      // TicketDrawer
      drawer: { visible: false, sucursalId: null, ticketId: null }
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() { this.reload(); }
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    reportKey() {
      return this.reportName;
    },
    baseFilters() {
      return Object.assign({}, this.filters, { page: this.page, page_size: this.perPage });
    },
    reload() {
      this.page = 1;
      this.drillPath = [];
      this.run();
    },
    run() {
      const name = this.reportKey();
      if (!name) return;
      this.loading = true;
      const f = this.baseFilters();
      const req = this.drillPath.length
        ? executiveService.drill(name, f, this.drillPath[this.drillPath.length - 1])
        : executiveService.run(name, f);
      req.then((res) => {
        const d = res.data || {};
        this.summary = d.summary || {};
        this.rows = d.rows || [];
        this.meta = d.meta || {};
        this.total = d.total || this.rows.length;
      }).catch((err) => {
        this.$emit('error', err);
        this.summary = {}; this.rows = []; this.total = 0;
      }).finally(() => { this.loading = false; });
    },
    setPage(p) {
      this.page = p;
      this.run();
    },
    // Drill-down: agrega un nivel según la columna clave de la fila.
    onDrill(item) {
      const next = this.nextDrill(item);
      if (!next) return;
      if (next.level === 'ticket') {
        this.drawer = { visible: true, sucursalId: next.sucursal_id, ticketId: next.key };
        return;
      }
      this.drillPath.push(next);
      this.page = 1;
      this.run();
    },
    // Deriva el siguiente nivel de drill de una fila. Las pestañas pueden sobreescribir.
    nextDrill(item) {
      if (item.ticket_id) {
        return { level: 'ticket', key: item.ticket_id, sucursal_id: item.sucursal_id, label: 'Ticket ' + item.ticket_id };
      }
      // key va como objeto: el backend lo decodifica como map (Drill.Key).
      if (item.customer_id) {
        return { level: 'tickets', key: { customer_id: item.customer_id }, label: item.name || item.nombre || ('Cliente ' + item.customer_id) };
      }
      if (item.sucursal_id) {
        return { level: 'customers', key: { sucursal_id: item.sucursal_id }, label: 'Sucursal ' + item.sucursal_id };
      }
      if (item.channel_code) {
        return { level: 'sucursal', key: { channel_code: item.channel_code }, label: item.channel_label || item.channel_code };
      }
      return null;
    },
    popDrill(i) {
      this.drillPath = this.drillPath.slice(0, i + 1);
      this.page = 1;
      this.run();
    },
    resetDrill() {
      this.drillPath = [];
      this.page = 1;
      this.run();
    },
    exportXlsx() {
      const name = this.reportKey();
      executiveService.exportXlsx(name, this.baseFilters()).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = name + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch((err) => this.$emit('error', err));
    },
    closeDrawer() {
      this.drawer.visible = false;
    },
    money(v) {
      const n = Number(v || 0);
      return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    num(v) {
      return Number(v || 0);
    }
  }
}
